
<template lang="pug">
  .account-popup
    .page-account.popup
      a.close(@click.prevent="close" @keydown.enter.prevent="close" aria-label="Close Popup" tabindex="0")
        <svg class="svg-icon" aria-hidden="true" style="width: 2.5em; height: 2.5em; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <path d="M777.856 280.192l-33.92-33.952-231.872 231.872-231.84-231.872-33.984 33.888 231.872 231.904-231.84 231.84 33.888 33.984 231.904-231.904 231.84 231.872 33.952-33.888-231.872-231.904z" />
        </svg>
      fieldset
        legend.title {{ address.id ? 'Edit Address' : 'Add New Address' }}
        form(@submit.prevent="submit")
          .row.two-cols
            div(v-bind:class="v$.address.first_name.$error ? 'has_error' : ''")
              label(for="user_first_name") First Name (Required)
              input(type="text" name="first_name" id="user_first_name" v-model="address.first_name")
              p.error(v-for="error of v$.address.first_name.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="user_first_name")
            div(v-bind:class="v$.address.last_name.$error ? 'has_error' : ''")
              label(for="user_last_name") Last Name (Required)
              input(type="text" name="last_name" id="user_last_name" v-model="address.last_name")
              p.error(v-for="error of v$.address.last_name.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="user_last_name")
          .row(v-bind:class="v$.address.company.$error ? 'has_error' : ''")
            label(for="address_company") Company
            input(type="text" name="company" id="address_company" v-model="address.company")
            p.error(v-for="error of v$.address.company.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="address_company")
          .row(v-bind:class="v$.address.address1.$error ? 'has_error' : ''")
            label(for="address_address1") Address
            input(type="text" name="address1" id="address_address1" v-model="address.address1")
            p.error(v-for="error of v$.address.address1.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="address_address1")
          .row(v-bind:class="v$.address.address2.$error ? 'has_error' : ''")
            label(for="address_address2") Address 2
            input(type="text" name="address2" id="address_address2" v-model="address.address2")
            p.error(v-for="error of v$.address.address2.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="address_address2")
          .row.two-cols
            div(v-bind:class="v$.address.city.$error ? 'has_error' : ''")
              label(for="user_city") City
              input(type="text" name="city" id="user_city" v-model="address.city")
              p.error(v-for="error of v$.address.city.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="user_city")
            div(v-bind:class="v$.address.province_code.$error ? 'has_error' : ''")
              label(for="address_province_code") State
              select(name="province_code" id="address_province_code" v-model="address.province_code")
                <option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AS">American Samoa</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">Washington DC</option><option value="FM">Micronesia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="GU">Guam</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MH">Marshall Islands</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="MP">Northern Mariana Islands</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PW">Palau</option><option value="PA">Pennsylvania</option><option value="PR">Puerto Rico</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VI">U.S. Virgin Islands</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option><option value="AA">Armed Forces Americas</option><option value="AE">Armed Forces Europe</option><option value="AP">Armed Forces Pacific</option>
              p.error(v-for="error of v$.address.province_code.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="province_code")
          .row(v-bind:class="v$.address.zip.$error ? 'has_error' : ''")
            label(for="user_zip") Zip
            input(type="text" name="zip" id="user_zip" v-model="address.zip")
            p.error(v-for="error of v$.address.zip.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="user_zip")
          .row
            label(for="address_country_code") Country / Region
            select(name="country_code" id="address_country_code" v-model="address.country_code")
              option(v-for="c of getCountries()" :value="c.id" v-html="c.name")
          .row(v-bind:class="v$.address.phone.$error ? 'has_error' : ''")
            label(for="address_phone") Phone
            input(type="text" name="phone" id="address_phone" v-model="address.phone")
            p.error(v-for="error of v$.address.phone.$errors" :key="error.$uid" v-html="error.$message" aria-describedby="address_phone")
          .row.actions
            button.btn--primary(@click.prevent="close") Cancel
            button.btn--primary(type="submit") Save
</template>

<script>
  import { email, required, minLength, numeric, minValue, maxValue, sameAs } from '@vuelidate/validators';
  import { useVuelidate } from '@vuelidate/core';
  import countries from 'scripts/misc/countries.js';

  export default {
    name: 'AddressPopup',

    components: {
    },

    props: {
      address: Object
    },

    setup() {
      return {
        v$: useVuelidate(null, null, {
          $lazy: true,
          $autoDirty: true
        })
      }
    },

    mounted() {
      if (this.$parent.showPopup === true) {
        const modal = document.querySelector('.page-account');
        const closeButton = modal.querySelector('.close');
        const lastButton = modal.querySelector('button[type=submit]');

        modal.addEventListener('keydown', function (e) {
          if (e.key === 'Tab') {
            if (closeButton.matches(':focus') && e.shiftKey) {
              e.preventDefault();
              lastButton.focus();
            } else if (lastButton.matches(':focus') && !e.shiftKey) {
              e.preventDefault();
              closeButton.focus();
            }
          }
        });
      }
    },

    data() {
      return {
        vuelidateExternalResults: {
          first_name: [],
          last_name: [],
          company: [],
          address1: [],
          address2: [],
          city: [],
          province_code: [],
          country_code: [],
          zip: [],
          phone: [],
        }
      }
    },

    validations () {
      return {
        address: {
          first_name: { required },
          last_name: { required },
          company: {},
          address1: {},
          address2: {},
          city: { required },
          province_code: { required },
          country_code: { required },
          zip: { required },
          phone: {},
        }
      }
    },

    methods: {
      getCountries() {
        return countries;
      },

      async submit() {
        for (const key in this.vuelidateExternalResults)
          this.vuelidateExternalResults[key] = [];

        const result = await this.v$.$validate();

        if (!result) {
          const firstErrorProperty = this.v$.$errors[0].$property;
          this.$el.querySelector(`[name=${firstErrorProperty}]`).focus();
          return;
        }

        if (this.address.id) {
          // Save
          fetch(
            this.$parent.$parent.url + 'update_address', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(Object.assign(this.address, this.$parent.$parent.getSession()))
            }
          ).then(response => response.json()).then(data => {
            if (data && !data.error && data.id) {
              const addr = this.$parent.addresses.find((v) => v.id == this.address.id);
              for (const k in data)
                addr[k] = data[k];
              this.$parent.addressUpdated = true;
              this.close();
            }
          }).catch(() => {
          });
        } else {
          // Create
          fetch(
            this.$parent.$parent.url + 'create_address', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(Object.assign(this.address, this.$parent.$parent.getSession()))
            }
          ).then(response => response.json()).then(data => {
            if (data && !data.error && data.id) {
              this.$parent.addresses.push(data);
              this.$parent.addressUpdated = true;
              this.close();
            }
          }).catch(() => {
          });
        }
      },

      close() {
        this.$parent.showPopup = false;
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
